import { Col, Row } from '@rematter/ui-web';
import { cn } from '@rematter/ui-web';

import { TradeEventDetail } from './TradeEventDetail';
import { TradeEventsList } from './TradeEventsList';
import { TradeEventsSidebar } from './TradeEventsSidebar';

import { useTradeAuditTab } from '@/audit-log/_state/tradeEvents.state';
import { useTranslations } from '@/audit-log/i18n/useTranslations';

export const TradeEventsView = () => {
  const t = useTranslations();
  const [tab, setTab] = useTradeAuditTab();

  return (
    <Col className="@TradeEventsView size-full">
      <Row className="border-b border-neutral/10 px-4">
        <button
          onClick={() => setTab('events')}
          className={cn(
            'px-4 py-3 text-sm font-medium transition-colors',
            tab === 'events'
              ? 'border-b-2 border-primary text-primary'
              : 'text-neutral/60 hover:text-neutral',
          )}
        >
          {t.tradeEventsView.tabs.events}
        </button>
        <button
          onClick={() => setTab('inbox')}
          disabled
          className={cn(
            'px-4 py-3 text-sm font-medium transition-colors',
            tab === 'inbox'
              ? 'border-b-2 border-primary text-primary'
              : 'cursor-not-allowed text-neutral/30',
          )}
        >
          {t.tradeEventsView.tabs.inbox}
        </button>
      </Row>
      <Row className="flex-1 items-stretch overflow-hidden">
        <TradeEventsSidebar />
        <TradeEventsList />
        <TradeEventDetail />
      </Row>
    </Col>
  );
};
